import {devs} from '../../../../package.json'

export const renderDevs = () => {
    if ((process.env.NODE_ENV || 'development') === 'production') {
        const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
        let primary_color = '#E20036'
        let secondary_color = '#111111'
        if (isDarkMode) {
            primary_color = '#E20036'
            secondary_color = '#ffffff'
        }

        const logFont = '-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;font-family:\'Poppins\', sans-serif;'
        const logGeneralStyles = logFont + 'font-size:32px;'
        const authorsStyles = logFont + '-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;font-family: "Rubik", sans-serif;font-size: 24px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: -0.3px;color:' + primary_color + ';'
        const authorsNameStyles = logFont + 'font-size:14px;color:' + secondary_color + ';'

        console.clear()
        console.log('%cAdvokaadibüroo Lepmets & Nõges',
            logGeneralStyles + 'color:' + primary_color + ';',
        )
        console.log('\n%cFrontend Development\n', authorsStyles)
        console.log('%c' + devs.frontend.join('\n'), authorsNameStyles)

        console.log('\n%cBackend Development\n', authorsStyles)
        console.log('%c' + devs.backend.join('\n'), authorsNameStyles)
    }
}
